import relativeTime from 'dayjs/plugin/relativeTime'
import marketService from 'services/market-service'
import { MarketOffer, MarketOffers } from 'models/market'
import { formatNumber } from 'utils/format-number'
import dayjs from 'dayjs'
import 'dayjs/locale/pl'

dayjs.extend(relativeTime)

declare const USER_BASE_URL_WT: string
const supportedCurrencies = document.querySelectorAll<HTMLElement>('[data-tables]')

const resetTimer = (): void => {
  const $timer = document.querySelector<HTMLSpanElement>('[data-compact-timer]')
  if ($timer) $timer.textContent = '10'
}

const cleanTableContent = ($table: HTMLTableElement): void => {
  const $tableTrElements = $table.querySelectorAll<HTMLTableRowElement>('tbody tr')
  $tableTrElements.forEach((el) => {
    el.parentNode.removeChild(el)
  })
}

const buildTableElements = (
  currencyID: string,
  $table: HTMLTableElement,
  singleOffer: MarketOffer,
  direction: string,
): void => {
  const $tableBody = $table.querySelector<HTMLTableElement>('tbody')

  const newRow = document.createElement('tr')

  const correctCurrencyAmount = formatNumber(direction === 'bid' ? singleOffer.counter_amount : singleOffer.amount, 2)
  const correctCurrencyID = direction === 'bid' ? 'PLN' : currencyID

  const newTableCellRate: HTMLTableCellElement = document.createElement('td')
  newTableCellRate.classList.add('compact__table-row-cell')
  newTableCellRate.textContent = formatNumber(singleOffer.rate, 4)

  const newTableCellAmount: HTMLTableCellElement = document.createElement('td')
  newTableCellAmount.classList.add('compact__table-row-cell')
  newTableCellAmount.textContent = `${correctCurrencyAmount} ${correctCurrencyID}`

  const newTableCellDate: HTMLTableCellElement = document.createElement('td')
  newTableCellDate.classList.add('compact__table-row-cell')

  const timeFromNow = dayjs(singleOffer.since).locale('pl').fromNow()

  newTableCellDate.textContent = timeFromNow

  newRow.appendChild(newTableCellRate)
  newRow.appendChild(newTableCellAmount)
  newRow.appendChild(newTableCellDate)

  $tableBody.prepend(newRow)
}

const updateGUI = (direction: string, offers: MarketOffer[], currencyID: string): void => {
  const $table = document.querySelector<HTMLTableElement>(`[data-direction=${direction}-${currencyID}]`)
  cleanTableContent($table)
  offers.forEach((singleOffer) => {
    buildTableElements(currencyID, $table, singleOffer, direction)
  })
}

const prepareData = (data: MarketOffers, currencyID: string): void => {
  const bidTableKey = `BID_${currencyID}_PLN`
  const askTableKey = `ASK_${currencyID}_PLN`

  const bestThreeBidOffers = data[bidTableKey].slice(0, 3).reverse()
  const bestThreeAskOffers = data[askTableKey].slice(0, 3).reverse()

  updateGUI('bid', bestThreeBidOffers, currencyID)
  updateGUI('ask', bestThreeAskOffers, currencyID)
  resetTimer()
}

const getMarketData = (): void => {
  supportedCurrencies.forEach((currency) => {
    const currencyID = currency.getAttribute('data-tables')

    marketService.fetchMarketPriceVolumes(USER_BASE_URL_WT, `${currencyID}_PLN`, '?brief=true').then((response) => {
      prepareData(response, currencyID)
    })
  })
}

const handleFeaturedTimer = (): void => {
  const $timer = document.querySelector<HTMLSpanElement>('[data-compact-timer]')
  if ($timer) {
    const actualTime = parseInt($timer.textContent, 10)
    $timer.textContent = String(actualTime > 0 ? actualTime - 1 : 0)
  }
}

const initCompactMarket = (): void => {
  getMarketData()
  setInterval(getMarketData, 10 * 1000) // handle every 10 seconds
  setInterval(handleFeaturedTimer, 1000)
}

export default initCompactMarket
